export default "__VITE_ASSET__CCAEXiGY__"